const KEY = "perfero_intro_seen";

let first = false;
try {
  first = !sessionStorage.getItem(KEY);
} catch {
  first = false;
}

export const isFirstVisit = first;
export const introDelay = first ? 1.5 : 0.15;

export const markIntroSeen = () => {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* storage unavailable */
  }
};
